import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import { withSnackbar } from 'notistack';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from 'components/CustomButtons/Button.jsx';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import waitlistFormStyle from "assets/jss/material-kit-react/components/waitlistFormStyle.jsx";

const axios = require('axios').default;

const WAITLIST_SETTINGS = {
  "URL": "https://z.wetheshareholders.com/waitlist",
  "METHOD": "POST"
};

// enqueueSnackbar and closeSnackbar
class WaitlistForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      listIds: props.listIds ? props.listIds : [],
      showSnackbar: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleFailure = this.handleFailure.bind(this);
    this.showSnackbar = this.showSnackbar.bind(this);
  }

  handleChange(event) {
    this.setState({email: event.target.value});
  }

  showSnackbar({message, variant}) {
    const key = `${this.props.id}-${variant}-${Math.floor(Math.random() * 1000)}`;
    const hideCallback = this.createHideSnackbarCallback(key).bind(this);
    this.props.enqueueSnackbar(<span id={key}>{message}</span>, {
      key,
      variant,
      transitionDuration: 3000,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      className: this.props.classes.snackbar,
      action: [
      <IconButton ariaLabel="Close" color="inherit">
      <CloseIcon onClick={hideCallback} style={{color: "white"}} />
      </IconButton>],
      ContentProps: {
        'ariaDescribedby': key,
      }
    }); 
  }

  createHideSnackbarCallback(key) {
    return function(){
      this.props.closeSnackbar(key);
    };
  }

  handleSuccess(response) {
  //Show Success Snackbar
    // console.log("sucess", response);
    this.setState({email: ''});
    this.showSnackbar({
      message: "Welcome! Email submitted.",
      variant: "success"
    });  
  }

  handleFailure(response) {
    //Show Failure Snackbar
    // console.log("failure", response);
    this.showSnackbar({
      message: "Sorry. Something went wrong.",
      variant: "error"
    });
  }

  handleSubmit(e) {
    // console.log("onSubmit event", {event: e, target: e.target, state: this.state});

    const data = {
      email: this.state.email,
      listIds: this.state.listIds
    };

    const handleSuccess = this.handleSuccess.bind(this);
    const handleFailure = this.handleFailure.bind(this);

    // console.log({url: WAITLIST_SETTINGS.URL, data});
    // handleFailure({});

    axios
    .post(WAITLIST_SETTINGS.URL, data)
    .then(response => {
    // {
    //   // `data` is the response that was provided by the server
    //   data: {},
    //   // `status` is the HTTP status code from the server response
    //   status: 200,
    //   // `statusText` is the HTTP status message from the server response
    //   statusText: 'OK',
    //   // `headers` the headers that the server responded with
    //   // All header names are lower cased
    //   headers: {},
    //   // `config` is the config that was provided to `axios` for the request
    //   config: {},
    //   // `request` is the request that generated this response
    //   // It is the last ClientRequest instance in node.js (in redirects)
    //   // and an XMLHttpRequest instance the browser
    //   request: {}
    // }

    // console.log({response});
    switch(Math.floor(response.status / 100)) {
      case 2:
        handleSuccess(response);
        break;
      case 5:
        handleFailure(response);
        break;
      default:
        handleFailure(response);
    }
    })
    .catch(function(error) {
      handleFailure(error);
    });

    e.preventDefault();
  }

  render() {
    const {
      buttonText,
      classes
    } = this.props;

    return (
      <form
        role="form"
        onSubmit={this.handleSubmit}
        >
        <GridContainer alignItems="flex-end">
          <GridItem xs={12} >
            <CustomInput
              className={classes.customInput}
              inputProps={{
                inputName: "email",
                required: true,
                type: "email",
                value: this.state.email,
                onChange: this.handleChange.bind(this),
              }}
              labelText="Your Email"
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <GridItem
            xs={12}
            className={classes.textCenter}
          >
            <Button type="submit" color="primary" fullWidth>{buttonText}</Button>
          </GridItem>
        </GridContainer>
      </form>
    )
  }
}


WaitlistForm.defaultProps = {
  buttonText: "Count Me In!",
  listIds: []
}

export default withSnackbar(withStyles(waitlistFormStyle)(WaitlistForm));